import { Link } from "react-router-dom";
import { CheckCircle2, Eye, Loader2, RotateCcw, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { CatalogWorkflowRecord } from "@/lib/api/catalog";
import type { CatalogReviewDialogAction } from "@/components/catalog/CatalogReviewActionDialog";

interface CatalogReviewQueueRowActionsProps {
  record: CatalogWorkflowRecord;
  disabled?: boolean;
  approving?: boolean;
  onApprove: (record: CatalogWorkflowRecord) => void;
  onOpenDialog: (record: CatalogWorkflowRecord, action: CatalogReviewDialogAction) => void;
}

export function CatalogReviewQueueRowActions({
  record,
  disabled = false,
  approving = false,
  onApprove,
  onOpenDialog,
}: CatalogReviewQueueRowActionsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <Button asChild variant="outline" size="sm">
        <Link to={`/catalog/physical/${record.id}/edit`}>
          <Eye className="mr-1 h-3.5 w-3.5" />
          Review
        </Link>
      </Button>
      <Button size="sm" disabled={disabled} onClick={() => onApprove(record)}>
        {approving ? (
          <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" />
        ) : (
          <CheckCircle2 className="mr-1 h-3.5 w-3.5" />
        )}
        Approve
      </Button>
      <Button
        size="sm"
        variant="outline"
        disabled={disabled}
        onClick={() => onOpenDialog(record, "return")}
      >
        <RotateCcw className="mr-1 h-3.5 w-3.5" />
        Return
      </Button>
      <Button
        size="sm"
        variant="destructive"
        disabled={disabled}
        onClick={() => onOpenDialog(record, "reject")}
      >
        <XCircle className="mr-1 h-3.5 w-3.5" />
        Reject
      </Button>
    </div>
  );
}
